import React, { Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const EssRepaymentNotificationsView = React.lazy(
    () => import('./views/EssRepaymentNotificationsView')
);

const LoadingFallback = () => (
    <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
    </div>
);

export const essRepaymentNotificationsRoutes: RouteObject[] = [
    {
        path: '/admin/ess-repayment-notifications',
        element: (
            <Suspense fallback={<LoadingFallback />}>
                <EssRepaymentNotificationsView />
            </Suspense>
        ),
    },
];
